import getters from "./getters";
import actions from "./actions";
import mutations from "./mutations";

const state = {
  contactList: [],
  contacts: { allContacts: [], current: [], unreadCount: 0 },
  contactListLoading: false,
  messages: { allMessages: [], current: [] },
  messagesLoading: false,
  connect: false,
  connectLoading: false,
  blockedUser: {},
  unblockedUser: {},
  blockedUserLoading: false,
  unblockedUserLoading: false,
  savedUser: {},
  savedUserLoading: false,
  searchedMessages: [],
  searchedMessagesLoading: false,
  currentPage: 1,
  pageHistory: [1],
  messagePageLoading: false,
  senderProfile: {},
  senderProfileLoading: false,
  contactListPage: 1,
  receiverProfile: {}
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
